/**
 * useMattleCampaign Hook
 *
 * Fetches and manages Mattle.fun campaign status.
 * Returns campaign details including:
 * - Whether campaign is active
 * - User's bonus points earned
 * - Remaining bonus available
 * - Campaign dates
 * - Whether user is in the Mattle whitelist
 */

import { useQuery } from '@tanstack/react-query';

import { getMattleCampaignStatus } from '@/api/auth';
import config from '@/config';

export function useMattleCampaign() {
  const query = useQuery({
    queryKey: ['mattleCampaign'],
    queryFn: async () => {
      const response = await getMattleCampaignStatus();
      if (response.code !== 0) {
        throw new Error(response.message || 'Failed to fetch campaign status');
      }
      return response.data;
    },
    enabled: config.ENABLE_MATTLE_CAMPAIGN, // Only fetch if feature flag is enabled
    staleTime: 30 * 1000, // Cache for 30 seconds
    refetchInterval: 60 * 1000, // Refetch every 60 seconds to keep countdown updated
  });

  return {
    campaignData: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
